/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Low_Credit_Banner_DismissInputs */

const en_low_credit_banner_dismiss = /** @type {(inputs: Low_Credit_Banner_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dismiss`)
};

const de_low_credit_banner_dismiss = /** @type {(inputs: Low_Credit_Banner_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schließen`)
};

const fr_low_credit_banner_dismiss = /** @type {(inputs: Low_Credit_Banner_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fermer`)
};

const es_low_credit_banner_dismiss = /** @type {(inputs: Low_Credit_Banner_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar`)
};

const it_low_credit_banner_dismiss = /** @type {(inputs: Low_Credit_Banner_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiudi`)
};

const nl_low_credit_banner_dismiss = /** @type {(inputs: Low_Credit_Banner_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sluiten`)
};

const pl_low_credit_banner_dismiss = /** @type {(inputs: Low_Credit_Banner_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zamknij`)
};

const fi_low_credit_banner_dismiss = /** @type {(inputs: Low_Credit_Banner_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sulje`)
};

const da_low_credit_banner_dismiss = /** @type {(inputs: Low_Credit_Banner_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luk`)
};

const sv_low_credit_banner_dismiss = /** @type {(inputs: Low_Credit_Banner_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stäng`)
};

/**
* | output |
* | --- |
* | "Dismiss" |
*
* @param {Low_Credit_Banner_DismissInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const low_credit_banner_dismiss = /** @type {((inputs?: Low_Credit_Banner_DismissInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Low_Credit_Banner_DismissInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_low_credit_banner_dismiss(inputs)
	if (locale === "fr") return fr_low_credit_banner_dismiss(inputs)
	if (locale === "es") return es_low_credit_banner_dismiss(inputs)
	if (locale === "it") return it_low_credit_banner_dismiss(inputs)
	if (locale === "nl") return nl_low_credit_banner_dismiss(inputs)
	if (locale === "pl") return pl_low_credit_banner_dismiss(inputs)
	if (locale === "fi") return fi_low_credit_banner_dismiss(inputs)
	if (locale === "da") return da_low_credit_banner_dismiss(inputs)
	if (locale === "sv") return sv_low_credit_banner_dismiss(inputs)
	return en_low_credit_banner_dismiss(inputs)
});